import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../../api';
import DashboardLayout from './DashboardLayout';

function EditArticle() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [article, setArticle] = useState(null);
  const [form, setForm] = useState({
    title: '',
    content: '',
    category: '',
    image: null,
  });

  useEffect(() => {
    api.get(`/articles/${id}`).then(res => {
      setArticle(res.data);
      setForm({
        title: res.data.title,
        content: res.data.content,
        category: res.data.category,
        image: null,
      });
    });
  }, [id]);

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleFile = e => {
    setForm(prev => ({ ...prev, image: e.target.files[0] }));
  };

  const handleSubmit = async e => {
    e.preventDefault();

    const data = new FormData();
    data.append('title', form.title);
    data.append('content', form.content);
    data.append('category', form.category);
    if (form.image) data.append('mainImage', form.image);

    await api.put(`/articles/${id}`, data);
    alert('Article updated!');
    navigate('/');
  };

  if (!article) return <p>Loading...</p>;

  return (
    <DashboardLayout>
      <form onSubmit={handleSubmit} className="max-w-xl mx-auto p-4 border rounded shadow">
        <h2 className="text-xl font-bold mb-4">Edit Article</h2>

        <input
          type="text"
          name="title"
          value={form.title}
          onChange={handleChange}
          placeholder="Title"
          className="w-full p-2 mb-2 border"
          required
        />

        <textarea
          name="content"
          value={form.content}
          onChange={handleChange}
          placeholder="Content"
          className="w-full p-2 mb-2 border h-40"
          required
        />

        <input
          type="text"
          name="category"
          value={form.category}
          onChange={handleChange}
          placeholder="Category"
          className="w-full p-2 mb-2 border"
          required
        />

        <div className="mb-2">
          <label>Replace Main Image:</label>
          <input type="file" onChange={handleFile} />
        </div>

        <button type="submit" className="bg-green-600 text-white px-4 py-2 rounded">
          Save Changes
        </button>

        <button
          type="button"
          className="ml-2 bg-gray-400 text-white px-4 py-2 rounded"
          onClick={() => navigate('/')}
        >
          Cancel
        </button>
      </form>
    </DashboardLayout>
  );
}

export default EditArticle;
